import axios from '@/axios.js'

const state = () => ({
    kontaks: [],
    kontak_tipe: []
})

const mutations = {
    SET_KONTAKS (state, payload) {
      state.kontaks = payload
    },
    SET_KONTAK_TIPE (state, payload) {
      state.kontak_tipe = payload
    },
    SET_KONTAK_GROUPS (state, payload) {
      state.kontaks = payload
    },
    ADD_KONTAK (state, item) {
      state.kontaks.unshift(item)
    },
    UPDATE_KONTAK (state, kontak) {
      const kontakIndex = state.kontaks.findIndex((p) => p.id === kontak.id)
      Object.assign(state.kontaks[kontakIndex], kontak)
    },
    REMOVE_KONTAK (state, itemId) {
      const ItemIndex = state.kontaks.findIndex((p) => p.id === itemId)
      state.kontaks.splice(ItemIndex, 1)
    },
}

const actions = {
  fetchKontak ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/term-list/kontak`)
        .then((response) => {
          commit('SET_KONTAKS', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchKontakTipe ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/term-list/kontak-tipe`)
        .then((response) => {
          commit('SET_KONTAK_TIPE', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchKontakGroup ({ commit }, slug) {
    return new Promise((resolve, reject) => {
      axios.get(`/term-list-group-meta/kontak/${slug}`)
        .then((response) => {
          commit('SET_KONTAK_GROUPS', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchKontakGroupTaxonomy ({ commit }, group) {
    return new Promise((resolve, reject) => {
      axios.get(`/term-list-group-taxonomy/kontak/${group}`)
      .then((response) => {
        if (response.data.data.length != 0) {
          commit('SET_KONTAK_GROUPS', response.data.data)
        }
        resolve(response.data)
      })
      .catch((error) => { reject(error) })
    })
  },
  fetchKontakGroupTaxonomySlug ({ commit }, group) {
    return new Promise((resolve, reject) => {
      axios.get(`/term-list-group-taxonomy-slug/kontak/${group}`)
      .then((response) => {
        if (response.data.data.length != 0) {
          commit('SET_KONTAK_GROUPS', response.data.data)
        }
        resolve(response.data)
      })
      .catch((error) => { reject(error) })
    })
  },
  addKontak ({ commit }, kontak ) {
    return new Promise((resolve, reject) => {
      axios.post('/term-add', kontak)
        .then((response) => {
          commit('ADD_KONTAK', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateKontak ({ commit }, kontak) {
    return new Promise((resolve, reject) => {
      axios.post(`/term-update/${kontak.id}`, kontak)
        .then((response) => {
            commit('UPDATE_KONTAK', response.data.data)
            resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeKontak ({ commit }, kontak) {
    return new Promise((resolve, reject) => {
      axios.delete(`/term-delete/${kontak.id}`)
        .then((response) => {
            commit('REMOVE_KONTAK', kontak.id)
            resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  }
}

export default {
  isRegistered: false,
  namespaced: true,
  state,
  actions,
  mutations
}